<template>
  <div style="display: none;"></div>
</template>

<script setup>
import { watch } from 'vue';
import { useGameStore } from '@/stores/gameStore';

const gameStore = useGameStore();

// Watch for font size changes and apply to CSS custom property
watch(() => gameStore.cardHeadingFontSize, (newSize) => {
  document.documentElement.style.setProperty('--card-heading-font-size', newSize / 100);
  document.documentElement.style.setProperty('--card-content-font-size', newSize / 100);
}, { immediate: true });
</script>
